import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { PASSWORD_RULES } from '@/utils/password-rules';

type Props = {
  password: string;
  confirm: string;
  visible: boolean;
};

function Row({ ok, label }: { ok: boolean; label: string }): ReactNode {
  return (
    <li className="flex items-center gap-xs text-xs text-text-tertiary">
      <span
        aria-hidden
        className={cn('font-mono', ok ? 'text-success' : 'text-text-tertiary')}
      >
        *
      </span>
      {label}
    </li>
  );
}

export function PasswordRequirements({
  password,
  confirm,
  visible,
}: Props): ReactNode {
  if (!visible) return null;
  return (
    <ul className="space-y-1 pl-sm pb-sm">
      {PASSWORD_RULES.map((r) => (
        <Row key={r.id} ok={r.test(password, confirm)} label={r.label} />
      ))}
    </ul>
  );
}
